import API from "./api";
import API_ROUTES from "./apiRoutes";

export const createPreApprovedInvite = async (payload) => {
  const res = await API.post(API_ROUTES.preApprovedInvites.list, payload);
  return res.data;
};

export const getMyPreApprovedInvites = async () => {
  const res = await API.get(API_ROUTES.preApprovedInvites.mine);
  return res.data;
};

export const getPreApprovedInviteById = async (id) => {
  const res = await API.get(API_ROUTES.preApprovedInvites.details(id));
  return res.data;
};

export const updatePreApprovedInvite = async (id, payload) => {
  const res = await API.put(API_ROUTES.preApprovedInvites.details(id), payload);
  return res.data;
};

export const cancelPreApprovedInvite = async (id) => {
  const res = await API.patch(API_ROUTES.preApprovedInvites.cancel(id));
  return res.data;
};

export const adminGateEntryLogs = async (params = {}) => {
  const res = await API.get(API_ROUTES.gate.adminEntryLogs, { params });
  return res.data;
};

export const searchPreApprovedInvite = async (code, societyId) => {
  const res = await API.get(API_ROUTES.gate.searchInvite, {
    params: { code, ...(societyId ? { society_id: societyId } : {}) },
  });
  return res.data;
};

export const checkInPreApprovedInvite = async (id) => {
  const res = await API.post(API_ROUTES.gate.checkInInvite(id));
  return res.data;
};

export const checkOutPreApprovedInvite = async (id) => {
  const res = await API.post(API_ROUTES.gate.checkOutInvite(id));
  return res.data;
};

export const denyPreApprovedInvite = async (id) => {
  const res = await API.post(API_ROUTES.gate.denyInvite(id));
  return res.data;
};

export const getAdminInviteStats = async (societyId) => {
  const res = await API.get(API_ROUTES.admin.inviteStats, { params: { society_id: societyId } });
  return res.data;
};

export const blockAdminInvite = async (id, status = "blocked") => {
  const res = await API.patch(API_ROUTES.admin.blockInvite(id), { status });
  return res.data;
};

export const getExpectedInvites = async (societyId) => {
  const res = await API.get(API_ROUTES.gate.expectedInvites, {
    params: { society_id: societyId },
  });
  return res.data;
};

export const generateInviteLink = async (payload) => {
  const res = await API.post("/invites/generate", payload);
  return res.data;
};
